import { data } from "framer-motion/client";
import generateReport from "../../services/AxiosReportService";
import api from "../../services/AxiosService";

export const generateTransactionsBalancesAuditReport = (data) => {
  return api("post", "api/audit/transaction-balance", "", data);
};

export const generateCustomerRegistrationAuditReport = (data) => {
  return api("post", "api/audit/customer-registration", "", data);
};

export const getAllBranches = () => {
  return api("get", "api/branches/list", "", null);
};

export const getAllBranchesByDistrictName = (data) => {
    return api("get", "api/branch-by-district-name", data, null);
}

export const getAllDistrict = () => {
    return api("get", "api/district-branch/list", "", null);
};

export const getAllDepositsProducts = () => {
  return api("get", "api/products/deposits", "", null);
};

export const getDistrictDivisionalBranchDetails = () => {
    return api("get","api/district-divisional-branch","",null)
}
export const getAllLoans = () => {
    return api("get", "api/products/loans", "", null);
};
export const amountWiseDisposeLoan=(data)=>{
    return api("post","api/audit/loan-dispose","",data);
}

export const generateGroupDepositAuditReport = (data) => {
  return api("post", "api/audit/group-deposit", "", data);
};

export const generateLoanValueIssuedAuditReport = (data) => {
  return api("post", "api/audit/loan-value-issued", "", data);
};

export const generateCompulsoryBalanceAccountReport = (data) => {
    return api("post", "api/audit/compulsory-balance-account-analysis", "", data);
};

export const generateLoanApplicationAuditReport = (data) => {
  return api("post", "api/audit/loan-application", "", data);
};

export const generateFixedDepositAnalysisAuditReport = (data) => {
  return api("post", "api/audit/fixed-deposit-analysis", "", data);
};

